export * from './cookie-acceptance.component';
